import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AvatarModule } from 'ngx-avatars';
import { Observable, Subject, takeUntil } from 'rxjs';
import { DateFormatPipe } from 'src/app/pipes/DateFormatPipe';
import { User } from '../../beans/User';
import { UserSelectors } from '../../store/user/user.selectors';
import { MyAccountSkeletonLoadingComponent } from './my-account-skeleton-loading/my-account-skeleton-loading.component';

import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';



@Component({
  selector: 'app-editable-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css'],
  standalone: true,
  imports: [CommonModule, AvatarModule, RouterModule, MatIconModule, DateFormatPipe, MyAccountSkeletonLoadingComponent, MatCardModule, MatDividerModule]
})
export class MyAccountComponent implements OnInit {
  destroy$: Subject<void> = new Subject<void>();
  user$: Observable<User> = this.store.select(UserSelectors.USER);
  user: User;
  passwordMessage: string | undefined;
  loading: boolean = true;
  datePipe: DateFormatPipe;
  constructor(private store: Store, public dialog: MatDialog, private actions$: Actions, private router: Router) {

  }

  ngOnInit() {
    this.user$.pipe(takeUntil(this.destroy$)).subscribe((user: User) => {
      if (user) {
        this.user = user;
        this.loading = false;
        this.passwordMessage = this.getPasswordUpdateMessage();
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPasswordUpdateMessage(): string {
    if (!this.user.isPasswordSet) {
      return 'Password not set';
    }
    if (!this.user?.passwordUpdatedAt) {
      return 'Password never changed';
    }
    let days = Math.floor((Date.now() - this.user.passwordUpdatedAt!) / (1000 * 3600 * 24))

    if (days <= 0) {
      return 'Last changed today';
    } else if (days === 1) {
      return 'Last changed 1 day ago';
    } else {
      return `Last changed ${days} days ago`;
    }
  }

  formatPhoneNumber(phoneNumber: string) {
    phoneNumber = phoneNumber.slice(3);
    // Remove all non-numeric characters
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Add spacing every five digits
    const formattedPhoneNumber = numericPhoneNumber.replace(/(\d{5})/g, '$1 ').trim();

    return formattedPhoneNumber;
  }

  getInitials(firstName?: string, lastName?: string): string {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return firstInitial ?? lastInitial;
  }

}
